// Real products from the user's School bag.zip — shown inside the interactive bag.
export const BAG_PRODUCTS = [
  {
    id: "bag-geometry",
    name: "Geometry Box",
    tag: "Instruments",
    color: "#1D3557",
    image: "/schoolbag/geometry_box_1.jpg",
    images: ["/schoolbag/geometry_box_1.jpg", "/schoolbag/geometry_box_2.jpg"],
    memory: "Compass, divider, protractor — aur woh 'compass de na' wali line har maths period.",
  },
  {
    id: "bag-crayons",
    name: "Camel Crayons",
    tag: "Colours",
    color: "#E9C46A",
    image: "/schoolbag/crayons.jpg",
    memory: "Drawing period ki jaan — wax crayons se bhari colouring book.",
  },
  {
    id: "bag-sketch",
    name: "Sketch Pens",
    tag: "Colours",
    color: "#6A0572",
    image: "/schoolbag/sketch_pens.jpg",
    memory: "Colour ke bina drawing adhoori — aur ek pen hamesha sookha nikalta tha.",
  },
  {
    id: "bag-inkpen",
    name: "Ink Pen",
    tag: "Pens",
    color: "#023E8A",
    image: "/schoolbag/ink_pen_1.jpg",
    images: ["/schoolbag/ink_pen_1.jpg", "/schoolbag/ink_pen_2.jpg"],
    memory: "Neeli ungliyan aur leaking cap ki tension — par likhaayi royal lagti thi.",
  },
  {
    id: "bag-gelpen",
    name: "Gel Pen (Add Gel)",
    tag: "Pens",
    color: "#0EA5E9",
    image: "/schoolbag/gel_pen.jpg",
    memory: "Smooth likhaayi, par exam se pehle hi khatam ho jaata tha.",
  },
  {
    id: "bag-trimax",
    name: "Reynolds Trimax",
    tag: "Pens",
    color: "#1D4ED8",
    image: "/schoolbag/trimax.jpg",
    images: ["/schoolbag/trimax.jpg", "/schoolbag/trimax_gold.jpg"],
    memory: "Gel pen jisne handwriting sudhaar di — Gold wala thoda premium feel.",
  },
  {
    id: "bag-ballpen",
    name: "Ball Pen",
    tag: "Pens",
    color: "#2563EB",
    image: "/schoolbag/ball_pen.jpg",
    memory: "₹5 wala reliable dost — poora class isse hi kaam chalata tha.",
  },
  {
    id: "bag-pencil",
    name: "Pencil",
    tag: "Writing",
    color: "#E63946",
    image: "/schoolbag/pencil.jpg",
    memory: "Sharpen karte-karte chhoti ho jaati thi, phir bhi phenkte nahi the.",
  },
  {
    id: "bag-sharpener",
    name: "Sharpener",
    tag: "Writing",
    color: "#E76F51",
    image: "/schoolbag/sharpener.jpg",
    memory: "Chhota sharpener, lamba curly chhilka — banane ka apna hi maza.",
  },
  {
    id: "bag-eraser",
    name: "Eraser",
    tag: "Writing",
    color: "#F1FAEE",
    image: "/schoolbag/eraser.jpg",
    memory: "Red-and-blue rubber — blue side ne kabhi kuch nahi mitaaya.",
  },
  {
    id: "bag-fevistick",
    name: "Fevistick",
    tag: "Craft",
    color: "#F4A261",
    image: "/schoolbag/fevistick.jpg",
    memory: "Bina mess ke chipkane wali stick — craft project ka asli hero.",
  },
];
